<!-- eslint-disable prettier/prettier -->
<template>
  <div class="w-full">
    <div class="w-full">
      <div class="flex items-center justify-start">
        <span class="mr-2 font-semibold text-base">New Connections</span>
        <span
          v-if="renderListFriendNews.length !== 0"
          class="rounded-full text-sm justify-center items-center flex w-6 h-6 border bg-blue-200"
          >{{ renderListFriendNews.length }}</span
        >
      </div>
    </div>
    <div class="w-full slider-like pt-4 pb-4">
      <div class="w-full flex" v-if="renderListFriendNews.length !== 0">
        <div class="mr-1">
          <div
            class="item-like cursor-pointer relative"
            @click="onClickShowListFriend()"
          >
            <div
              class="image-avatar"
              :style="{
                'background-image': `url(${imageDefault})`,
              }"
            >
              <div class="overlay"></div>
            </div>

            <div
              class="absolute bottom-0 flex justify-center items-center top-0 right-0 p-2 left-0 text-left text-white"
            >
              <span
                class="bg-teal-500 p-1 w-8 h-8 flex justify-center items-center rounded-full"
                >{{ renderListFriendNews.length }}</span
              >
            </div>
          </div>
        </div>
        <Carousel v-bind="settings" :breakpoints="breakpoints">
          <Slide
            v-for="(item, index) in renderListFriendNews"
            @click="onClickShowDetailUser(item)"
            :key="index"
          >
            <div
              class="item-like cursor-pointer"
              v-if="item.profiles?.avatars[0]"
            >
              <div
                class="image-avatar"
                :style="{
                  'background-image': `url(${item.profiles?.avatars[0]?.meta.url})`,
                }"
              >
                <div class="overlay"></div>
              </div>

              <div class="absolute bottom-0 p-2 left-0 text-left text-white">
                <div
                  :title="item.fullname"
                  class="text-xs w-[50px] text-ellipsis overflow-hidden whitespace-nowrap"
                >
                  {{ item.fullname }}
                </div>
              </div>
            </div>
          </Slide>
        </Carousel>
      </div>

      <div class="w-full" v-if="renderListFriendNews.length === 0">
        <div class="w-full flex items-center justify-center p-5">
          <img
            src="../../assets/icon_svg/ic_match_default.svg"
            width="100"
            alt=""
          />
        </div>
        <div class="text-center text-sm pl-10 pr-10">
          No friends. Make friends with many people
        </div>
      </div>
    </div>

    <div class="w-full pt-4 pb-4 border-t-2">
      <div class="flex justify-between items-center gap-2">
        <div class="flex items-center gap-2">
          <img src="../../assets/icon_svg/ic_person.svg" alt="" />
          <div class="text-base text-stone-00 font-semibold">Contact user</div>
        </div>

        <div class="cursor-pointer">
          <img src="../../assets/icon_svg/ic_search.svg" width="16" alt="" />
        </div>
      </div>

      <div class="w-full" v-if="renderListFriend.length === 0">
        <div class="flex justify-center items-center p-5">
          <img src="../../assets/icon_svg/ic_icon_app.svg" width="100" alt="" />
        </div>
        <div class="text-center text-sm pl-10 pr-10">
          Let's connect hearts with many people to have the opportunity to text
          each other
        </div>
      </div>
      <div class="w-full mt-3" v-if="renderListFriend.length !== 0">
        <div
          class="w-full flex justify-between items-center cursor-pointer gap-1 p-1 pad-btn"
          v-for="(item, index) in renderListFriend"
          @click="onClickMessage(item)"
          :key="index"
        >
          <div class="w-[50px]">
            <div
              v-if="item.profiles?.avatars[0]"
              :style="{
                'background-image': `url(${item.profiles?.avatars[0]?.meta.url})`,
              }"
              class="rounded-full size-image-small relative"
            >
              <div
                v-if="item.onlineNow === true"
                class="rounded-full bg-white p-[2px] absolute bottom-0 left-7"
              >
                <img
                  src="../../assets/icon_svg/ic_online.svg"
                  class="mr-2"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="pt-3 pb-3 w-[calc(100%-50px)] text-left">
            <div class="font-text-bh">
              {{ item.fullname }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue3-carousel";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "menu-right",
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      imageDefault: require("@/assets/icon_svg/image_default.jpg"),

      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        // 700px and up
        700: {
          itemsToShow: 3.5,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 5.5,
          snapAlign: "start",
        },
      },
    };
  },

  computed: {
    renderListFriendNews() {
      console.log("object", this.$store.state.messageModule.listFriends);
      return this.$store.state.messageModule.listFriends;
    },

    renderListFriend() {
      return this.$store.state.messageModule.listBetFriends;
    },
  },

  mounted() {},

  methods: {
    ...mapActions(["getListMessageChanel", "updateStatusMessage"]),
    ...mapMutations(["setListMessageSelected", "setInformationUserFriend"]),

    async onClickMessage(val) {
      debugger;

      await this.getListMessageChanel({
        chanelId: val.channelId,
        pageSize: 50,
        currentPage: 0,
      }).then((data) => {
        // Xét giá trị cho Mutation: để show popup nhắn tin
        this.setListMessageSelected({
          idChannel: val.channelId,
          dataClient: data.clients,
          isShowForm: true,
          dataMessages: data.list_data,
        });

        this.$emit("onShowFormChat", true);
      });
    },

    onClickShowDetailUser(val) {
      this.setInformationUserFriend(val);
      this.$emit("onShowDetailFriendNew", true);
    },

    onClickShowListFriend() {
      this.$emit("onShowListFriend", true);
    },
  },
};
</script>

<style lang="css" scoped>
.item-like {
  width: 90px;
  border-radius: 10px;
  overflow: hidden;
  border-radius: 12px;
}
.image-avatar {
  width: 90px;
  height: 110px;
  border-radius: 12px;
  background-size: cover; /* Hiển thị ảnh với tỷ lệ ảnh gốc và điều chỉnh kích thước để không cắt bớt */
  background-position: center; /* Canh giữa ảnh */
  background-repeat: no-repeat; /* Không lặp lại ảnh */
  overflow: hidden;
  position: relative;
}

.overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40%; /* Adjust as needed */
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.719),
    rgba(0, 0, 0, 0)
  ); /* Gradient from black to transparent */
  pointer-events: none; /* Ensure the overlay does not block interactions */
}
</style>
